<template>
  <div>
    <PageAllow controller="ReturnBaskets" action="view"/>
    <Breadcrumbs :items="items" />

    <!-- 退框单明细信息 -->
    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-expansion-panels v-model="panelsA" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{  $t("CRUD.info", [$t("ReturnBasketDetail.ObjectName")]) }}
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="return_basket.status | returnBasketStatusColor"
                :text-color="return_basket.status | returnBasketStatusTextColor"
              >
                {{ return_basket.status | returnBasketStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <!-- 采购计划单号 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnBasketDetail.Fields.code")}}{{ $t("Global.colon") }}
                  </span>
                  {{ return_basket.code }}
                </v-card>
              </v-col>
              <!-- 创建者 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnBasketDetail.Fields.creater")}}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ return_basket && return_basket.creater ? return_basket.creater.name : "" }}
                  </span>
                </v-card>
              </v-col>
              <!-- 创建时间 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnBasketDetail.Fields.created")}}{{ $t("Global.colon") }}
                  </span>
                  {{ return_basket.created | formatTime }}
                </v-card>
              </v-col>
              <!-- 门店 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReturnBasketDetail.Fields.shop", [this.$consts.shopName()])}}{{ $t("Global.colon") }}
                  </span>
                  {{ return_basket.shop ? return_basket.shop.shop_code + ' / ' + return_basket.shop.shop_name : "" }}
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>

    <!-- 按商品分组 -->
    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-expansion-panels v-model="panelsB" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{  $t("ReturnBasketDetail.returnBasketDetails") }}
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-data-table
              :headers="basketDetailHeaders"
              :items="return_basket_details"
              multi-sort
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item.Description="{ item }">
                {{ $t(settings
                ? settings.material_name_display_type == 4
                  ? "Material.nameWithCodeAndStandard"
                  : settings.material_name_display_type == 3
                  ? "Material.materialNameWithCodeAndStandard"
                    : settings.material_name_display_type == 2
                    ? "Material.materialNameWithCode"
                  : "Material.materialName"
                : "Material.materialName",
                [
                  item.material_code,
                  item.material_name,
                  item.standard_name,
                ]) }}
              </template>
              <template v-slot:item.total_return_price="{ item }">
                <span>
                  {{ $t('Global.money') }}{{item.total_return_price | formatMoney}}
                </span>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>

    <!-- 按退货单明细 -->
    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-expansion-panels v-model="panelsC" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{$t("ReturnBasketDetail.returnOrderDetails") }}
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-data-table
              :headers="orderDetailHeaders"
              :items="return_order_details"
              multi-sort
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item.return_order_code="{ item }">
                <a
                  style="text-decoration: none"
                  :href="'/#/return-orders/' + item.return_order_id"
                >
                  {{ item.return_order_code }}
                </a>
                <v-chip
                  small
                  label
                  :color="item.return_order_status | returnOrderStatusColor"
                  :text-color="item.return_order_status | returnOrderStatusTextColor"
                >{{ item.return_order_status | returnOrderStatusText }}
                </v-chip>
              </template>
              <template v-slot:item.order_code="{ item }">
                <a
                  style="text-decoration: none"
                  :href="'/#/orders/' + item.order_id"
                >
                  {{ item.order_code }}
                </a>
              </template>
              <template v-slot:item.Description="{ item }">
                {{ $t(settings
                ? settings.material_name_display_type == 4
                  ? "Material.nameWithCodeAndStandard"
                  : settings.material_name_display_type == 3
                  ? "Material.materialNameWithCodeAndStandard"
                    : settings.material_name_display_type == 2
                    ? "Material.materialNameWithCode"
                  : "Material.materialName"
                : "Material.materialName",
                [
                  item.material_code,
                  item.material_name,
                  item.standard_name,
                ]) }}
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import ReturnBaskets from "@/api/return_baskets.js";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.returnOrderManagement"),
          disabled: false,
          replace: true,
          href: "/return-orders",
        },
        {
          text: i18n.t("Nav.returnBaskets"),
          disabled: false,
          href: "/return-baskets",
        },
        {
          text: i18n.t("ReturnBasketDetail.title"),
          disabled: true,
          href: "/return-baskets",
        },
      ];
      return items;
    },
    basketDetailHeaders() {
      let headers = [
        {
          text: i18n.t("ReturnBasketDetail.Fields.category_name"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.Description"),
          align: "start",
          sortable: false,
          value: "Description",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.apply_num"),
          align: "start",
          sortable: false,
          value: "apply_num",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.return_num"),
          align: "start",
          sortable: false,
          value: "return_num",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.wait_return_num"),
          align: "start",
          sortable: false,
          value: "wait_return_num",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.total_return_price"),
          align: "start",
          sortable: false,
          value: "total_return_price",
        }
      ];
      return headers;
    },
    orderDetailHeaders() {
      let headers = [
        {
          text: i18n.t("ReturnBasketDetail.Fields.return_order_code"),
          align: "start",
          sortable: false,
          value: "return_order_code",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.order_code"),
          align: "start",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.category_name"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.Description"),
          align: "start",
          sortable: false,
          value: "Description",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.apply_num"),
          align: "start",
          sortable: false,
          value: "apply_num",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.return_num"),
          align: "start",
          sortable: false,
          value: "return_num",
        },
        {
          text: i18n.t("ReturnBasketDetail.Fields.wait_return_num"),
          align: "start",
          sortable: false,
          value: "wait_return_num",
        }
      ];
      return headers;
    },
    ...mapState(["settings", "accountUser", "accountInfo"]),
  },

  data: () => ({
    panelsA: [0],
    panelsB: [0],
    panelsC: [0],
    return_basket: [],
    return_basket_details: [],
    return_order_details: [],
    return_orders: [],
  }),

  mounted() {
    this.getReturnBasketsDetailsFromAPI()
  },

  methods: {
    getReturnBasketsDetailsFromAPI() {
      ReturnBaskets.fetchOne(this.$route.params.id, {
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.return_basket = response.data.return_basket;
            this.return_basket_details = [];
            for (let index in response.data.return_basket.return_basket_details) {
              this.return_basket_details.push(response.data.return_basket.return_basket_details[index])
            }
            this.return_order_details = response.data.return_order_details;
            this.return_orders = response.data.return_orders;
          }
        }.bind(this)
      );
    },
  },

  watch: {},
};
</script>